var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuesSayDo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.746 22.428H7.262a2.792 2.792 0 01-2.79-2.789v-3.235a2.792 2.792 0 012.79-2.786h2.484a2.793 2.793 0 012.79 2.786v3.235a2.792 2.792 0 01-2.79 2.79zm-2.484-7.441a1.42 1.42 0 00-1.417 1.417v3.235a1.417 1.417 0 001.417 1.417h2.484a1.416 1.416 0 001.418-1.417v-3.235a1.42 1.42 0 00-1.418-1.417H7.262z",
    fill: "url(#values_say_do_svg__paint0_linear_3701_999)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.056 30.604a.689.689 0 01-.683-.647c-.064-.906-.527-3.43-1.883-4.27l-2.155-1.152a5.678 5.678 0 01-5.921.003l-2.151 1.148c-1.356.845-1.818 3.365-1.883 4.271a.68.68 0 01-.731.647.682.682 0 01-.647-.727c0-.162.297-3.983 2.556-5.358h.032l2.527-1.353a.686.686 0 01.718.049 4.358 4.358 0 002.53.815 4.333 4.333 0 002.524-.819.692.692 0 01.722-.048l2.533 1.355h.032c2.265 1.376 2.543 5.197 2.556 5.358a.688.688 0 01-.647.732l-.029-.004z",
    fill: "url(#values_say_do_svg__paint1_linear_3701_999)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.237 20.7c-.1.001-.2-.02-.292-.06a.69.69 0 01-.394-.622V2.17A2.174 2.174 0 0116.72 0h15.107A2.174 2.174 0 0134 2.171v12.295a2.174 2.174 0 01-2.17 2.17H20.29l-4.614 3.9a.68.68 0 01-.44.165zM16.722 1.37a.802.802 0 00-.803.802v16.368l3.68-3.109a.692.692 0 01.442-.162h11.787a.802.802 0 00.803-.799V2.174a.802.802 0 00-.803-.802l-15.106-.003z",
    fill: "url(#values_say_do_svg__paint2_linear_3701_999)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.449 6.614l-.602-.152a.049.049 0 01-.035-.036 2.914 2.914 0 00-.324-.822.045.045 0 010-.048l.324-.53a.049.049 0 000-.059l-.648-.647a.045.045 0 00-.058 0l-.53.323a.046.046 0 01-.049 0 2.912 2.912 0 00-.822-.323.045.045 0 01-.035-.036c-.026-.1-.123-.482-.152-.602a.051.051 0 00-.046-.035h-.909a.045.045 0 00-.045.035l-.152.602a.064.064 0 01-.036.036 2.912 2.912 0 00-.822.323.045.045 0 01-.048 0l-.505-.3c-.048-.03-.071-.026-.087 0l-.647.647a.055.055 0 000 .058l.323.53a.052.052 0 010 .049 2.911 2.911 0 00-.323.822.042.042 0 01-.036.035l-.598.152a.048.048 0 00-.036.046v.909a.042.042 0 00.036.045l.598.152a.049.049 0 01.036.036c.065.289.174.566.323.822a.052.052 0 010 .048l-.323.534a.055.055 0 000 .058l.647.647a.048.048 0 00.058 0l.534-.323a.061.061 0 01.048 0c.255.157.532.273.822.343a.049.049 0 01.036.035l.152.599a.042.042 0 00.045.036h.91a.049.049 0 00.045-.036l.152-.599a.042.042 0 01.035-.035c.29-.07.568-.186.822-.343a.062.062 0 01.049 0l.53.323a.048.048 0 00.058 0l.648-.647a.049.049 0 000-.058l-.324-.534a.045.045 0 010-.048c.149-.256.258-.533.324-.822a.064.064 0 01.035-.036l.602-.152a.045.045 0 00.036-.045v-.91a.051.051 0 00-.003-.041.052.052 0 00-.033-.026zM21.99 8.57a1.46 1.46 0 01-1.456-1.456 1.456 1.456 0 111.456 1.456z",
    fill: "url(#values_say_do_svg__paint3_linear_3701_999)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.286 10.512c.022-.24.004-.481-.055-.715l.392-.323-.324-.663-.505.113a2.202 2.202 0 00-.54-.466l.035-.518-.705-.23-.275.437a2.2 2.2 0 00-.715.052l-.323-.391-.648.323.114.505a2.202 2.202 0 00-.466.54l-.518-.035-.23.702.437.278c-.022.239-.004.479.052.712l-.392.323.324.647.505-.113a2.2 2.2 0 00.54.466l-.036.514.703.233.278-.436c.238.022.48.004.712-.055l.323.391.647-.323-.097-.482c.184-.154.341-.336.466-.54l.515.035.233-.706-.447-.275zm-2.184.677a.874.874 0 110-1.747.874.874 0 010 1.747z",
    fill: "url(#values_say_do_svg__paint4_linear_3701_999)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_say_do_svg__paint0_linear_3701_999",
    x1: -8.5,
    y1: 18.016,
    x2: 35.995,
    y2: 18.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_say_do_svg__paint1_linear_3701_999",
    x1: -7.258,
    y1: 26.84,
    x2: 34.5,
    y2: 26.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_say_do_svg__paint2_linear_3701_999",
    x1: -4.5,
    y1: 9.942,
    x2: 35.996,
    y2: 10.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_say_do_svg__paint3_linear_3701_999",
    x1: -4,
    y1: 6.997,
    x2: 36.997,
    y2: 7.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_say_do_svg__paint4_linear_3701_999",
    x1: -3,
    y1: 10.205,
    x2: 36.497,
    y2: 10.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })))));
}
export default __webpack_public_path__ + "static/values_say_do.11edda7f.svg";
export { SvgValuesSayDo as ReactComponent };